export default "__VITE_ASSET__643900b7__"